import {
  formatFilterSummary,
  resolveFilterValue,
} from "app/store/dashboard/surgery_types_procedures/utils/filterValues";
import useActiveProcedure from "components/pages/dashboard/surgery_types_procedures/hooks/useActiveProcedure";

const useCriteriaSummary = () => {
  const { activeProcedure, procedureFilters, hasActiveFilters } =
    useActiveProcedure();

  const items = activeProcedure.filters.map((filter) =>
    formatFilterSummary(filter, resolveFilterValue(filter, procedureFilters))
  );

  return { items, isUnrestricted: !hasActiveFilters };
};

export default useCriteriaSummary;
